export const Language = {
  pl: 'pl',
  en: 'en',
}
